import * as Moment from 'moment';
import { extendMoment } from 'moment-range';
import { ScheduleDate } from '@akiba/models_bimbo';
const moment = extendMoment(Moment);

export enum DateCalculatorTypeEnum {
    daily = 1,
    weekly = 2,
    biweekly = 3,
    bimonthly = 4,
    monthly = 5
}

export interface CalculatorResult {
    enValue: string;
    esValue: string;
    id: number;
    values: Array<Date>;
}

export class DateCalculator {

    types: any = {
        diario: 1,
        semanal: 2,
        catorcenal: 3,
        quincenal: 4,
        mensual: 5,
        daily: 1,
        weekly: 2,
        biweekly: 3,
        bimonthly: 4,
        monthly: 5,
        1: 'daily',
        2: 'weekly',
        3: 'biweekly',
        4: 'bimonthly',
        5: 'monthly'
    };

    toUTC = false;
    endDate: Date | null = null;

    constructor() {
    }

    calculateDates(startDate: Date, wageType: string, type: number | string): Array<ScheduleDate> {

        const endOfYear = new Date();

        endOfYear.setFullYear(2025, 11, 31);
        const results = this.calculateDate(type, startDate, endOfYear);

        const pdArray = results.values.map(element => {
            const aMoment = moment(element);
            const pd = new ScheduleDate();
            pd.startDate = aMoment.startOf('day').toDate();
            pd.endDate = aMoment.endOf('day').toDate();
            pd.weekNumber = aMoment.isoWeek();
            const isoWeek = aMoment.isoWeek() / 2;
            pd.biWeekNumber = Math.ceil(isoWeek);
            pd.appliesToWageType = wageType;
            pd.active = true;
            pd.scheduleDay = aMoment.isoWeekday();
            return pd;
        });

        return pdArray;

    }

    calculateDate(frequency: string | number, startDate: Date, max: Date | number | null = null) {

        if (max) {
            if (max instanceof Date) {
                this.endDate = max;
            } else if (typeof max === 'number') {
                this.endDate = this.calculateEndFrequencyByNumber(frequency, startDate, max);
            }
        } else {
            const nDate = new Date();
            nDate.setFullYear(nDate.getFullYear() + 1);
            this.endDate = nDate;
        }

        if (this.toUTC) {
            startDate.setUTCHours(0, 0, 1);
            this.endDate.setUTCHours(23, 59, 59);
        } else {
            startDate.setHours(0, 0, 1);
            this.endDate.setHours(23, 59, 59);
        }



        const startMoment: Moment.Moment = moment(startDate);
        const endMoment: Moment.Moment = moment(this.endDate);

        let aFrequency = frequency;
        if (typeof frequency === 'string') {
            aFrequency = this.types[frequency];
        }

        switch (aFrequency) {

            case 1: {
                return this.calculateDays(startMoment, endMoment);
            }
            case 2: {
                return this.calculateWeeks(startMoment, endMoment);
            }
            case 3: {
                return this.calculateBiWeek(startMoment, endMoment);
            }
            case 4: {
                return this.calculateBiMonths(startMoment, endMoment);
            }
            case 5: {
                return this.calculateMonths(startMoment, endMoment);
            }
            default: {
                return this.calculateDays(startMoment, endMoment);
            }

        }

    }

    nextDayOfWeek(afterDate: Date, plusNumberOfDays: number, dayOfWeek: number): Date {

        if (this.toUTC) {
            afterDate.setUTCHours(0, 0, 1);
        } else {
            afterDate.setHours(0, 0, 1);
        }

        const aDay = moment(afterDate);
        const d = dayOfWeek;
        aDay.add(plusNumberOfDays, 'd');

        if (plusNumberOfDays === 0) {
            aDay.isoWeekday(d);
            const aDate = aDay.toDate();
            return aDate;
        }

        if (aDay.isoWeekday() <= d) {
            aDay.isoWeekday(d);
            const aDate = aDay.toDate();
            return aDate;
        } else {
            aDay.add(1, 'weeks').isoWeekday(d);
            const aDate = aDay.toDate();
            return aDate;
        }


    }

    private calculateDays(startMoment: Moment.Moment, endMoment: Moment.Moment): CalculatorResult {

        const day = { enValue: 'daily', esValue: 'diario', id: 1, values: [] };

        const range = moment().range(startMoment, endMoment);
        day.values = Array.from(range.by('days')).map(mObj => {
            return mObj.toDate();
        });

        return day;

    }

    private calculateWeeks(startMoment: Moment.Moment, endMoment: Moment.Moment): CalculatorResult {

        const week = { enValue: 'weekly', esValue: 'semanal', id: 2, values: [] };

        const range = moment().range(startMoment, endMoment);
        week.values = Array.from(range.by('weeks')).map(mObj => {
            return mObj.toDate();
        });

        return week;

    }

    private calculateBiWeek(startMoment: Moment.Moment, endMoment: Moment.Moment): CalculatorResult {

        const biWeek = { enValue: 'biweekly', esValue: 'catorcenal', id: 3, values: [] };

        const startClone = startMoment.clone();
        const endClone = endMoment.clone();

        const range = moment().range(startClone, endClone);
        const dates = Array.from(range.by('weeks')).map(mObj => {
            return mObj.toDate();
        });

        const len = dates.length;

        for (let i = 0; i < len; i += 2) {

            const m = dates[i];
            biWeek.values.push(m);

        }

        return biWeek;

    }

    private calculateBiMonths(startMoment: Moment.Moment, endMoment: Moment.Moment): CalculatorResult {

        const biMonth = { enValue: 'bimonthly', esValue: 'quincenal', id: 4, values: [] };

        const startClone = startMoment.clone();
        const endClone = endMoment.clone();

        const range = moment().range(startClone, endClone);
        const dates = Array.from(range.by('months'));
        const len = dates.length;

        for (let i = 0; i < len; i++) {

            const m: any = dates[i];
            const eom = m.add(1, 'months').date(1).subtract(1, 'days');
            const q = eom.clone();
            q.date(15);

            if (range.contains(q)) {
                biMonth.values.push(q.toDate());
            }

            if (range.contains(eom)) {
                biMonth.values.push(eom.toDate());
            }

        }

        return biMonth;

    }

    private calculateMonths(startMoment: Moment.Moment, endMoment: Moment.Moment): CalculatorResult {

        const month = { enValue: 'monthly', esValue: 'mensual', id: 5, values: [] };
        const startClone = startMoment.clone();
        const endClone = endMoment.clone();
        const range = moment().range(startClone, endClone);
        const dates = Array.from(range.by('months')).map(mObj => {
            return mObj.toDate();
        });

        month.values = dates;
        return month;

    }

    private calculateEndFrequencyByNumber(frequency: string | number, startDate: Date, numberOfTimes: number): Date {

        const startMoment: Moment.Moment = moment(startDate);

        let aFrequency = frequency;
        if (typeof frequency === 'string') {
            aFrequency = this.types[frequency];
        }

        switch (aFrequency) {

            case 1: {
                return startMoment.add(numberOfTimes, 'days').toDate();
            }
            case 2: {
                return startMoment.add(numberOfTimes, 'weeks').toDate();
            }
            case 3: {
                const x = numberOfTimes * 14;
                return startMoment.add(x, 'days').toDate();
            }
            case 4: {
                const x = numberOfTimes * 15;
                return startMoment.add(x, 'days').toDate();
            }
            case 5: {
                return startMoment.add(numberOfTimes, 'months').toDate();
            }
            default: {
                return startMoment.add(numberOfTimes, 'days').toDate();
            }

        }

    }

}
